'use strict';

define('features/tss/tss',[
  'jquery',
  'components/slicker',
  'lib/util/tda.config',
  'disclaimers',
  'lib/scroller',
  'lib/analytics/blocks/index',
  'lib/analytics/pageload',
  'lib/analytics/click',
  'lib/analytics/context.add'
], function (
  $,
  Slicker,
  tdaConfig,
  disclaimers,
  scroller,
  blocks,
  anPageLoad,
  anClicks,
  anAddContext
) {
  var TssComponent = function (el, config) {
    this._el = $(el);
    this._config = config;
    this.initialize.apply(this, arguments);
  };

  // This is how we get the series! Wow!
  function getVehicleSeries() {
    var pathArray = window.location.pathname.split('/');

    var i = 0;
    var j = 0;
    if (pathArray[1] === 'en' || pathArray[1] === 'es') {
      i = 3;
      j = 4;
    } else {
      i = 2;
      j = 3;
    }

    var vehicleSeries = '';
    var url = '';
    if (pathArray[i] === 'vehicles') {
      vehicleSeries = pathArray[j];
    } else if (pathArray[i] === 'compare') {
      vehicleSeries = pathArray[j].split('-')[1];
    } else if (pathArray[i] === 'inventory-detail') {
      url = new URL(window.location.href);
      vehicleSeries = url.searchParams.get('series');
    } else if (pathArray[i] === 'offer-detail') {
      url = new URL(window.location.href);
      var offerid = url.searchParams.get('offerid');
      vehicleSeries = offerid.split('_')[0];
    } else {
      console.log('Unknown page type!');
    }

    return vehicleSeries;
  }

  function hideTSS() {
    var series = getVehicleSeries();
    if (BATSiteConfig.tssNotAvailable.indexOf(series) > -1) {
      return true;
    }
    return false;
  }

  $.extend(TssComponent.prototype, {
    initialize: function () {
      console.log('TssComponent initialize: ', this);
    },

    load: function (el) {
      var self = this;
      self.$el = $(el);
      this.seriesFromUrl = getVehicleSeries();
      this.$scope = $('#section_tss');
      if (hideTSS()) {
        $('.tss-component').hide();
      } else {
        this.slideshow();
        this.analytics();
      }
      $(document).ready(function () {
        disclaimers.addLocalDisclaimers();
      });
    },

    slideshow: function () {
      var self = this;
      self.imageSlides = new Slicker({
        $slider: $('.tss-component-slideshow .carousel-inner'),
        slickOptions: {
          mobileFirst: true,
          fade: false,
          slide: 'li',
          slidesToShow: 1,
          infinite: false,
          autoplay: false,
          arrows: true,
          dots: true,
          paddingBottom: 60,
          responsive: [{
            breakpoint: 960,
            settings: {
              appendArrows: $('.tss-component-slideshow'),
              prevArrow: '<button tabIndex="0" class="slick-prev-btn"><i class="icon icon-arrow-thin-left"></i> <span>Previous Feature</span></button>',
              nextArrow: '<button tabIndex="0" class="slick-next-btn"><span>Explore Features</span> <i class="icon icon-arrow-thin-right"></i></button>',
              appendDots: $('.tss-component'),

              customPaging: function (slider, i) {
                var title = $(slider.$slides[i]).data('title');
                var elString = '<a tabIndex="0" class="datalayer-link tss-slide-button">' + title + '</a>';
                return elString;
              },
            }
          }],

          initFunction: function () {
            $('.tss-component-slideshow .slide-text sup a').each(function (index, item) {
              $(item).addClass('datalayer-link');
              // BAT-3862
              var itmTxt = $(item).text();
              $(item).data('linktext', 'Disclaimer ' + itmTxt);
            });
            // BAT-4016 ADA FUNCTIONALITY FOR BTNS.
            $('.tss-slide-button').each(function (index, item) {
              $(item).keydown(function (event) {
                if (event.keyCode === 13) {
                  $(event.target).trigger('click');
                }
              });
            });
          },

          beforeFunction: function (e, slick, currentSlide, nextSlide) {
            var nxtDl = $(slick.$slides).eq(nextSlide).data('layer');
            anAddContext(
              self.$scope,
              blocks.sectionBlock(nxtDl.content_section)
            );
          }
        }
      });
      self.customSlideNav();
    },

    analytics: function () {
      anAddContext(
        this.$scope,
        blocks.sectionBlock('bat_tss_overview'),
        blocks.seriesBlock({ series_code: this.seriesFromUrl })
      );
      anClicks(this.$scope);
      scroller.add(this.$scope, {
        after: function afterView() {
          anPageLoad($(this));
        }
      });
    },

    customSlideNav: function () {
      $('.tss-component-slideshow .carousel-inner').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        if (nextSlide !== 0) {
          $('.slick-next-btn span').text('Next Feature');
        } else {
          $('.slick-next-btn span').text('Explore Features');
        }
      });
      $('.slick-dots').append('<li class="explore-tss-link datalayer-link"><a href="/' + tdaConfig.site.context_url + '/tools/toyota-safety-sense/">Explore TSS <i class="icon icon-arrow-thin-right"></i></a></li>');
    }
  });

  return TssComponent;
});

